import {
  ApplicantNotificationDetails,
  INotificationItem,
  PositionNotificationDetails,
} from "@/features/notifications/models/Notifications";
import { ToastNotification } from "@/models/ToastNotification";
import router from "@/router";
import { useNotificationStore } from "@dafcoe/vue-notification";
import moment from "moment";
import { TYPES } from "@/types";
import { myContainer } from "@/inversify.config";
import { IEmploymentService } from "@/interfaces/IEmploymentService";
const { setNotification } = useNotificationStore();
const client = myContainer.get<IEmploymentService>(TYPES.IEmploymentService);

export default {
  state: {
    notifications: [],
    unreadNotifications: 0,
  },

  getters: {
    notifications: (state: any) => state.notifications,
  },

  mutations: {
    setNotifications(state: any, notifications: any) {
      state.notifications = notifications;
      state.unreadNotifications = state.notifications.filter(
        (n: INotificationItem) => !n.read
      ).length;
    },
  },

  actions: {
    async createNotification(
      { commit, state }: any,
      notification: INotificationItem
    ) {
      const note = {
        id: state.notifications.length + 1,
        type: notification.type,
        timestamp: moment(),
        title: notification.title,
        message: notification.message,
        callback: notification.callback,
        read: false,
      };
      commit("setNotifications", [note, ...state.notifications]);
    },

    async createPositionNotification(
      { commit, state, dispatch }: any,
      details: PositionNotificationDetails
    ) {
      const notificationId = state.notifications.length + 1;
      const text = moment(details.positionPublishDate).isBefore(
        moment().add(1, "days")
      )
        ? "har publicerats"
        : `är skapad och publiceras ${moment(
            details.positionPublishDate
          ).format("YYYY-MM-DD")}`;

      const title = moment(details.positionPublishDate).isBefore(
        moment().add(1, "days")
      )
        ? "Ny position publicerad"
        : "Ny position skapad";

      const note = {
        id: notificationId,
        type: "position",
        timestamp: moment(),
        title: title,
        message: `Tjänsten <strong class="font-semibold text-darkGray-3">${details.positionName}</strong> ${text}`,
        callback: () => {
          router.push(`/admin/positions/${details.positionId}`);
          dispatch("markAsRead", notificationId);
        },
        read: false,
      };
    },

    async createApplicantNotification(
      { commit, state, dispatch }: any,
      details: ApplicantNotificationDetails
    ) {
      const notificationId = state.notifications.length + 1;

      const note = {
        id: notificationId,
        type: "applicant",
        timestamp: moment(),
        title: "Ny ansökan",
        message: `<strong class="font-semibold text-darkGray-3">${details.applicantName}</strong> har sökt till tjänsten <strong class="font-semibold text-darkGray-3">${details.positionName}</strong>`,
        callback: () => {
          router.push(
            `/admin/positions/${details.positionId}/applicants/${details.applicantId}`
          );
          dispatch("markAsRead", notificationId);
        },
        read: false,
      };
    },

    async addNotification({ commit, dispatch }: any, item: ToastNotification) {
      const toastNotification = {
        message: item.Message,
        type: item.Type,
        showIcon: true,
        dismiss: {
          manually: true,
          automatically: true,
        },
        duration: 1500,
        showDurationProgress: true,
        appearance: "light",
      };
      setNotification(toastNotification);
    },
    async addNotificationItem(
      { commit, dispatch, state }: any,
      item: INotificationItem
    ) {
      const _notifications = [...state.notifications, item];
      _notifications.sort((a, b) => b.timestamp - a.timestamp);
      commit("setNotifications", _notifications);
    },

    async loadNotifications({ commit, getters }: any) {
      const notifications: Array<INotificationItem> = [];

      commit("setNotifications", notifications);
    },

    async loadNotification({ commit, getters }: any, id: number) {
      const notifications = getters.notifications;
      commit("setNotifications", notifications);
    },

    async markAsRead({ commit, getters, state }: any, id: number) {
      const notifications = getters.notifications;
      const notification = notifications.find((x: any) => x.id === id);
      if (notification) {
        notification.read = true;
      }
      commit("setNotifications", notifications);
    },

    async markAsUnread({ commit, getters, state }: any, id: number) {
      const notifications = getters.notifications;
      const notification = notifications.find((x: any) => x.id === id);
      if (notification) {
        notification.read = false;
      }
      commit("setNotifications", notifications);
    },

    async markAllAsRead({ commit, getters }: any) {
      const notifications = getters.notifications;
      notifications.forEach((x: any) => {
        if (!x.read) {
          x.read = true;
        }
      });
      commit("setNotifications", notifications);
    },

    async deleteNotification(
      { commit, getters }: any,
      item: INotificationItem
    ) {
      const notifications = getters.notifications;

      const notification = getters.notifications.find(
        (x: any) => x.id === item.id
      );
      if (notification) {
        notifications.splice(notifications.indexOf(notification), 1);
      }

      await client.deleteNotificationById(
        notification.id,
        getters.container.id
      );
      commit("setNotifications", notifications);
    },

    async deleteAllNotifications(
      { commit, getters }: any,
      containerId: number
    ) {
      const notifications = getters.notifications;
      notifications.splice(0, notifications.length);
      await client.Container.deleteNotificationByContainerId(containerId);
      commit("setNotifications", notifications);
    },
  },
};
